import { initI18n } from '@dvb/common';
import '@dvb/ui/src/assets/css/animate.css';
import '@dvb/ui/src/assets/css/index.css';
import '@dvb/ui/src/assets/css/utils/react-toastify.css';
import '@milestone-portal/assets/css/index.css';
import { RouterProvider } from '@tanstack/react-router';
import { createRoot } from 'react-dom/client';

import { AppContainer } from './container/AppContainer';
import { router } from './router';

initI18n();

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <AppContainer>
      <RouterProvider router={router} />
    </AppContainer>
  );
}
